<div class="catalog">
  <!-- Convenzione: dà il prezzo ai prodotti dei servizi B2B, che non hanno listino. -->
  <section *ngIf="!loading && !loadError && (convention || hasB2BServices || conventionError)" class="fh-card convention-card">
    <div class="convention-head">
      <div class="d-flex align-items-center gap-3 min-w-0">
        <span class="line-tile tone-caregiving"><i class="bi bi-patch-check"></i></span>
        <div class="min-w-0">
          <div class="d-flex flex-wrap align-items-center gap-2">
            <h3 class="h6 fw-semibold mb-0">Convenzione</h3>
            <span *ngIf="convention" class="chip" [ngClass]="convention.status === 'ACTIVE' ? 'chip-success' : 'chip-muted'">
              {{ statusLabels[convention.status] }}
            </span>
            <span class="chip chip-muted">Dimostrativa</span>
          </div>
          <div class="small text-muted-fh mt-1">
            <ng-container *ngIf="convention; else noConventionTpl">Validità: {{ validityText(convention) }}</ng-container>
            <ng-template #noConventionTpl>
              I prodotti dei servizi B2B non hanno prezzi di listino: il prezzo si definisce nella convenzione.
            </ng-template>
          </div>
        </div>
      </div>
      <button
        *ngIf="!conventionError"
        type="button"
        class="btn btn-sm text-nowrap"
        [ngClass]="convention ? 'btn-outline-primary' : 'btn-primary text-light'"
        (click)="conventionModal = true"
      >
        <i class="bi me-1" [ngClass]="convention ? 'bi-pencil' : 'bi-plus-lg'"></i>{{ convention ? 'Modifica' : 'Crea convenzione' }}
      </button>
    </div>

    <div *ngIf="convention" class="convention-stats">
      <div>
        <div class="label">Monte ore totale</div>
        <div class="value">{{ convention.totalHours ? convention.totalHours + ' ore' : '—' }}</div>
      </div>
      <div>
        <div class="label">Monte ore condiviso</div>
        <div class="value">
          <ng-container *ngIf="convention.sharedHoursPool?.enabled; else poolOffTpl">
            {{ convention.sharedHoursPool?.hours ? convention.sharedHoursPool?.hours + ' ore' : 'Attivo' }}
            <span class="sub">tra {{ poolLinesText(convention) }}</span>
          </ng-container>
          <ng-template #poolOffTpl>Non attivo</ng-template>
        </div>
      </div>
      <div>
        <div class="label">Prodotti con prezzo</div>
        <div class="value">{{ convention.rules?.length || 0 }}</div>
      </div>
    </div>

    <div *ngIf="conventionError" class="alert alert-warning small mb-0 mt-3 d-flex align-items-center justify-content-between gap-3">
      <span>{{ conventionError }}</span>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="load()">Riprova</button>
    </div>
  </section>

  <!-- Filtri -->
  <div class="toolbar">
    <div class="d-flex flex-wrap gap-2">
      <button type="button" class="area-chip" [class.on]="area === 'all'" (click)="area = 'all'">
        Tutte <span class="count">{{ countFor('all') }}</span>
      </button>
      <button
        type="button"
        *ngFor="let id of areaOrder"
        class="area-chip"
        [ngClass]="areas[id].tone"
        [class.on]="area === id"
        (click)="area = id"
      >
        <span class="dot"></span>{{ areas[id].label }} <span class="count">{{ countFor(id) }}</span>
      </button>
    </div>
    <div class="flex-grow-1"></div>
    <div class="position-relative search">
      <i class="bi bi-search position-absolute top-50 translate-middle-y ms-3 text-muted-fh"></i>
      <input
        type="search"
        class="form-control ps-5"
        placeholder="Cerca servizio o prodotto…"
        [(ngModel)]="query"
        aria-label="Cerca servizio o prodotto"
      />
    </div>
    <button type="button" class="btn btn-primary text-light text-nowrap" (click)="openService()">
      <i class="bi bi-plus-lg me-1"></i>Aggiungi servizio
    </button>
  </div>

  <!-- Stati -->
  <div *ngIf="loading" class="fh-card p-5 text-center text-muted-fh">
    <span class="spinner-border spinner-border-sm me-2"></span>Carico servizi, prodotti e prezzi…
  </div>

  <div *ngIf="!loading && loadError" class="alert alert-danger d-flex align-items-center justify-content-between gap-3">
    <span>{{ loadError }}</span>
    <button type="button" class="btn btn-sm btn-outline-danger" (click)="load()">Riprova</button>
  </div>

  <div *ngIf="!loading && !loadError && !items.length" class="empty">
    <i class="bi bi-diagram-3 fs-2 d-block mb-2"></i>
    <div class="fw-semibold text-body">Nessun servizio collegato</div>
    <p class="small mb-3">Collega un servizio esistente o creane uno nuovo per questa azienda.</p>
    <button type="button" class="btn btn-primary text-light" (click)="openService()">
      <i class="bi bi-plus-lg me-1"></i>Aggiungi servizio
    </button>
  </div>

  <div *ngIf="!loading && items.length && !visibleItems.length" class="empty">Nessun servizio corrisponde ai filtri.</div>

  <!-- Servizi -->
  <section
    *ngFor="let item of visibleItems"
    class="fh-card service-card"
    [class.is-disabled]="item.service.disabled"
    [ngClass]="areas[areaOf(item)].tone"
  >
    <header class="service-head">
      <div class="d-flex align-items-center gap-3 min-w-0">
        <span class="line-tile"><i class="bi" [ngClass]="lineOf(item.service.businessLine).icon"></i></span>
        <div class="min-w-0">
          <div class="d-flex flex-wrap align-items-center gap-2">
            <h3 class="h6 fw-semibold mb-0">{{ item.service.name }}</h3>
            <span class="chip chip-tone">{{ lineOf(item.service.businessLine).label }}</span>
            <span class="chip">{{ item.service.customerType }}</span>
          </div>
          <div class="small text-muted-fh mt-1">
            Servizio #{{ item.service.id }} · {{ areas[areaOf(item)].label }} · {{ item.products.length }}
            {{ item.products.length === 1 ? 'prodotto' : 'prodotti' }}
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center gap-2">
        <span class="small" [class.text-success]="!item.service.disabled" [class.text-muted-fh]="item.service.disabled">
          {{ item.service.disabled ? 'Disattivato' : 'Attivo' }}
        </span>
        <div class="form-check form-switch m-0">
          <input
            class="form-check-input"
            type="checkbox"
            role="switch"
            [checked]="!item.service.disabled"
            [disabled]="toggling.has(item.service.id)"
            (change)="toggleService(item)"
            aria-label="Servizio attivo"
          />
        </div>
        <button type="button" class="icon-btn" title="Modifica servizio" (click)="openService(item.service)">
          <i class="bi bi-pencil"></i>
        </button>
        <a class="icon-btn" title="Apri la scheda completa del servizio" [routerLink]="['/services', item.service.id]">
          <i class="bi bi-box-arrow-up-right"></i>
        </a>
      </div>
    </header>

    <div class="table-scroll">
      <table class="products">
        <thead>
          <tr>
            <th>Prodotto</th>
            <th>Tipo</th>
            <th>{{ isB2B(item.service) ? 'Prezzo in convenzione' : 'Prezzi' }}</th>
            <th class="text-end"></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let row of item.products">
            <tr>
              <td>
                <div class="fw-medium">{{ row.product.name }}</div>
                <div class="mono text-muted-fh">#{{ row.product.id }} · {{ row.product.stripeID || 'senza Stripe ID' }}</div>
              </td>
              <td><span class="chip">{{ productTypeLabel(row.product.type) }}</span></td>
              <!-- Servizio B2B: prezzo dalla convenzione -->
              <td *ngIf="isB2B(item.service)">
                <div class="d-flex flex-wrap gap-1">
                  <ng-container *ngIf="ruleOf(row.product) as rule; else noRuleTpl">
                    <button type="button" class="chip chip-primary price-chip" [disabled]="!!conventionError" (click)="openRule(item, row.product)">
                      <b>{{ rulePriceText(rule, isCaregiving(item.service)) }}</b>
                    </button>
                    <span *ngIf="ruleQuantityText(rule, isCaregiving(item.service)) as quantity" class="chip">{{ quantity }}</span>
                  </ng-container>
                  <ng-template #noRuleTpl><span class="chip chip-muted">Non in convenzione</span></ng-template>
                </div>
              </td>
              <td *ngIf="!isB2B(item.service)">
                <div class="d-flex flex-wrap gap-1">
                  <button
                    type="button"
                    *ngFor="let group of priceGroups(row)"
                    class="chip chip-primary price-chip"
                    [title]="group.stripeID || 'senza Stripe ID'"
                    (click)="toggleExpanded(row.product.id)"
                  >
                    <b>{{ euro(group.amount) }}</b> · {{ provincesText(group) }}
                  </button>
                  <span *ngIf="!row.prices.length" class="chip chip-muted">Nessun prezzo</span>
                </div>
              </td>
              <td class="text-end text-nowrap">
                <button
                  *ngIf="isB2B(item.service)"
                  type="button"
                  class="link-btn me-3"
                  [disabled]="!!conventionError"
                  (click)="openRule(item, row.product)"
                >
                  {{ ruleOf(row.product) ? 'Modifica prezzo' : 'Imposta prezzo' }}
                </button>
                <button *ngIf="!isB2B(item.service)" type="button" class="link-btn me-3" (click)="toggleExpanded(row.product.id)">
                  Prezzi ({{ row.prices.length }})
                  <i class="bi" [ngClass]="expanded.has(row.product.id) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                </button>
                <button type="button" class="icon-btn d-inline-grid" title="Modifica prodotto" (click)="openProduct(item, row)">
                  <i class="bi bi-pencil"></i>
                </button>
              </td>
            </tr>
            <tr *ngIf="!isB2B(item.service) && expanded.has(row.product.id)" class="prices-row">
              <td colspan="4">
                <div class="prices-box">
                  <table *ngIf="row.prices.length" class="prices">
                    <thead>
                      <tr>
                        <th>Provincia</th>
                        <th class="text-end">Importo</th>
                        <th>Stripe ID</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let price of sortedPrices(row)">
                        <td>{{ provinceLabel(price.province) }}</td>
                        <td class="text-end fw-semibold tabular">{{ euro(price.amount) }}</td>
                        <td class="mono text-muted-fh">{{ price.stripeID || '—' }}</td>
                        <td class="text-end">
                          <button type="button" class="icon-btn d-inline-grid" title="Modifica prezzo" (click)="openPrice(item, row.product, price)">
                            <i class="bi bi-pencil"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div *ngIf="!row.prices.length" class="small text-muted-fh mb-2">Questo prodotto non ha ancora prezzi.</div>
                  <button type="button" class="link-btn" (click)="openPrice(item, row.product)">
                    <i class="bi bi-plus-lg me-1"></i>Aggiungi prezzo
                  </button>
                </div>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="!item.products.length">
            <td colspan="4" class="text-center text-muted-fh small py-4">Nessun prodotto in questo servizio.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <footer class="service-foot">
      <button type="button" class="link-btn" (click)="openProduct(item)">
        <i class="bi bi-plus-lg me-1"></i>Aggiungi prodotto
      </button>
    </footer>
  </section>
</div>

<app-catalog-service-modal
  *ngIf="serviceModal"
  [company]="company"
  [service]="serviceModal.service"
  [linkedIds]="linkedIds"
  (saved)="onSaved($event)"
  (closed)="closeModals()"
></app-catalog-service-modal>

<app-catalog-product-modal
  *ngIf="productModal"
  [company]="company"
  [service]="productModal.item.service"
  [product]="productModal.product"
  [priceCount]="productModal.priceCount"
  (saved)="onSaved($event)"
  (closed)="closeModals()"
></app-catalog-product-modal>

<app-catalog-price-modal
  *ngIf="priceModal"
  [company]="company"
  [service]="priceModal.item.service"
  [product]="priceModal.product"
  [price]="priceModal.price"
  (saved)="onSaved($event)"
  (closed)="closeModals()"
></app-catalog-price-modal>

<app-catalog-rule-modal
  *ngIf="ruleModal && convention"
  [companyId]="company.id"
  [service]="ruleModal.item.service"
  [product]="ruleModal.product"
  [convention]="convention"
  (saved)="onSaved($event)"
  (closed)="closeModals()"
></app-catalog-rule-modal>

<app-catalog-convention-modal
  *ngIf="conventionModal"
  [companyId]="company.id"
  [convention]="convention"
  [lines]="companyLines"
  (saved)="onSaved($event)"
  (closed)="closeModals()"
></app-catalog-convention-modal>
